import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import { Theme } from '@cian/ui-kit';
import { IconPlaceholderImage16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';
import { trackOpenFullscreenGallery } from './tracking';
import { FullscreenGallery } from '../../components/FullscreenGallery';
import { Content } from '../../components/FullscreenGallery/Content';
import { IApplicationState } from '../../types/redux';
import { FullscreenGalleryHeaderContainer } from '../FullscreenGalleryHeader';

export function FullscreenGalleryContainer() {
  const [isOpened, setOpenedState] = React.useState(false);

  const gallery = useSelector((state: IApplicationState) => state.galleryMedia);

  const onButtonClick = React.useCallback(() => {
    setOpenedState(true);
    trackOpenFullscreenGallery();
  }, [setOpenedState]);

  const onClose = React.useCallback(() => {
    setOpenedState(false);
  }, [setOpenedState]);

  return (
    <>
      <Theme theme="onOverlay">
        <Button
          theme="stroke_secondary"
          onClick={onButtonClick}
          beforeIcon={<IconPlaceholderImage16 color="icon-inverted-default" />}
          data-testid="FullscreenGalleryButton"
        >
          Галерея Комплекса
        </Button>
      </Theme>
      {isOpened && (
        <FullscreenGallery
          onClose={onClose}
          header={<FullscreenGalleryHeaderContainer onClose={onClose} />}
          content={<Content gallery={gallery} />}
        />
      )}
    </>
  );
}
